import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TableVirtuoso } from 'react-virtuoso';
import { List, ListItem, Divider, makeStyles } from '@material-ui/core';
import moment from 'moment';
import VehicleTablecell from './VehicleTablecell';
import { useNavigate } from 'react-router';
import { reportSubmenu, roadSubmenu, titleTableHeader } from './constance';
import { setTimeSearching } from 'src/features/deviceSlice';
import SearchIcon from '@material-ui/icons/Search';
import SettingsIcon from '@material-ui/icons/Settings';
import { Box, InputAdornment, TextField, Typography, CircularProgress } from '@material-ui/core';
import axiosInterceptor from 'src/app/axiosInterceptor';
import CarStatusBar from 'src/app/components/maps/CarStatusBar';

// Ô này lọc danh sách đang tải; ngoài ra còn hỏi server để tìm thiết bị ở đại lý KHÁC,
// rồi nhảy thẳng sang đại lý chứa thiết bị đó.
const REMOTE_SEARCH_MIN_CHARS = 2;
const REMOTE_SEARCH_DEBOUNCE_MS = 400;
const REMOTE_SEARCH_LIMIT = 20;

// Table/TableRow khai MỘT lần ngoài component. Khai inline trong prop `components` thì mỗi render
// là component mới: TableVirtuoso gỡ cả bảng và mọi dòng rồi dựng lại, VehicleTablecell mount lại
// và đọc scrollWidth — ép trình duyệt tính layout toàn trang. Dữ liệu động đi qua `context`.
const MiniTable = props => (
  <table
    {...props}
    style={{
      ...props.style,
      borderCollapse: 'collapse',
      border: '1px solid rgba(60, 64, 67, 0.15)',
      backgroundColor: '#f5f5f5',
      tableLayout: 'fixed',
      width: '100%'
    }}
  />
);

const MiniTableRow = ({ item, context, ...props }) => {
  const vId = item.device_id || item.id;
  const isActive = vId === context.rowActive;
  const index = Number(props['data-index']);
  return (
    <tr
      {...props}
      onClick={() => context.onRowClick(item, index)}
      onMouseEnter={() => context.setHoverIndex(index)}
      onMouseLeave={() => context.setHoverIndex(null)}
      style={{
        ...props.style,
        borderBottom: '1px solid rgba(60, 64, 67, 0.15)',
        cursor: 'pointer',
        backgroundColor: isActive
          ? '#ffe4e1'
          : context.hoverIndex === index
            ? '#ebebebff'
            : 'transparent',
        transition: 'background-color 0.15s linear',
        willChange: 'background-color'
      }}
    />
  );
};

const MINI_COMPONENTS = { Table: MiniTable, TableRow: MiniTableRow };

const useStyles = makeStyles(theme => ({
  menuItem: {
    padding: '8px 12px',
    transition: 'background-color 0.2s ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0'
    }
  }
}));

const VehicleTableMini = ({ vehicles, getVehicle, idSelected, showSearch = true, total, extraCount = 0, baseDeviceCount, carStatus, setCarStatus }) => {
  const [rowActive, setRowActive] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [allVehicles, setAllVehicles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [menuPosition, setMenuPosition] = useState(null);

  const [submenuPosition, setSubmenuPosition] = useState(null);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [menuType, setMenuType] = useState([]);
  const [vehicleSub, setVehicleSub] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();

  const isAgency = useSelector(state => state.authSlice.isAgency);
  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const canSearchAllAgencies = isAdmin || isAgency;
  const [remoteResults, setRemoteResults] = useState([]);
  const [remoteLoading, setRemoteLoading] = useState(false);
  const remoteSearchRef = React.useRef(null);
  const isCustomerCare = useSelector(state => state.authSlice.isCustomerCare);
  const listVehicleTracking = useSelector(
    state => state.vehicleSlice?.listVehicleTracking || []
  );
  const expiredCount = listVehicleTracking.filter((v) => v.debt).length;
  const activeCount = baseDeviceCount !== undefined ? baseDeviceCount - expiredCount : 0;

  const isCamera4G =
    vehicleSub && (vehicleSub.device_type === 'VGPS_2CAM' || vehicleSub.vehicle?.device_type === 'VGPS_2CAM' || vehicleSub.device_type === 'VGPS_4CAM' || vehicleSub.vehicle?.device_type === 'VGPS_4CAM') ? true : false;
  const isCar4G =
    (vehicleSub && (vehicleSub.device_type === 'VGPS_2CAM' || vehicleSub.vehicle?.device_type === 'VGPS_2CAM' || vehicleSub.device_type === 'VGPS_4CAM' || vehicleSub.vehicle?.device_type === 'VGPS_4CAM')) ||
      (vehicleSub && (vehicleSub.device_type === 'VGPS_CAR4G' || vehicleSub.vehicle?.device_type === 'VGPS_CAR4G'))
      ? true
      : false;

  useEffect(() => {
    let filtered = [...vehicles];
    if (searchTerm) {
      const lowerSearch = searchTerm.toLowerCase();
      filtered = filtered.filter(v => {
        const vData = v.vehicle || v;
        const name = vData?.name || '';
        const lp = vData?.license_plate || v.license_plate || '';
        return name.toLowerCase().includes(lowerSearch) ||
          lp.toLowerCase().includes(lowerSearch);
      });
    }

    const sortedVehicles = filtered.sort((a, b) => {
      if (a.debt && !b.debt) return 1;
      if (!a.debt && b.debt) return -1;
      const idA = a.device_id || a.id;
      const idB = b.device_id || b.id;
      return idB - idA;
    });
    setAllVehicles(sortedVehicles);
  }, [vehicles, searchTerm]);

  useEffect(() => {
    if (remoteSearchRef.current) clearTimeout(remoteSearchRef.current);

    const keyword = searchTerm.trim();
    if (!canSearchAllAgencies || keyword.length < REMOTE_SEARCH_MIN_CHARS) {
      setRemoteResults([]);
      setRemoteLoading(false);
      return;
    }

    setRemoteLoading(true);
    remoteSearchRef.current = setTimeout(async () => {
      try {
        const res = await axiosInterceptor.get(
          `/vehicles/tracking/search?keywords=${encodeURIComponent(keyword)}&limit=${REMOTE_SEARCH_LIMIT}`
        );
        setRemoteResults(res?.data?.payload?.devices || []);
      } catch (err) {
        setRemoteResults([]);
      } finally {
        setRemoteLoading(false);
      }
    }, REMOTE_SEARCH_DEBOUNCE_MS);

    return () => {
      if (remoteSearchRef.current) clearTimeout(remoteSearchRef.current);
    };
  }, [searchTerm, canSearchAllAgencies]);

  // Chỉ gợi ý những thiết bị KHÔNG có trong danh sách đang mở — thiết bị đang mở đã hiện ở bảng dưới.
  const remoteOnlyResults = React.useMemo(() => {
    if (remoteResults.length === 0) return [];
    const loadedIds = new Set(vehicles.map(v => String(v.device_id || v.id)));
    return remoteResults.filter(d => !loadedIds.has(String(d.device_id)));
  }, [remoteResults, vehicles]);

  const handlePickRemoteDevice = device => {
    if (!device?.agency_id) return;
    setSearchTerm('');
    setRemoteResults([]);
    navigate(`/app/tracking?agency_id=${device.agency_id}&device_id=${device.device_id}`);
  };

  const virtuosoRef = React.useRef(null);
  const lastScrolledIdRef = React.useRef(null);

  useEffect(() => {
    if (idSelected !== undefined && idSelected !== null) {
      setRowActive(idSelected);

      if (idSelected !== lastScrolledIdRef.current) {
        const index = allVehicles.findIndex(v => {
          const vId = v.device_id || v.id;
          return String(vId) === String(idSelected);
        });

        if (index !== -1 && virtuosoRef.current) {
          virtuosoRef.current.scrollToIndex({
            index,
            align: 'center',
            behavior: 'smooth'
          });
          lastScrolledIdRef.current = idSelected;
        }
      }
    } else if ((idSelected === undefined || idSelected === null) && rowActive) {
      setRowActive(null);
      lastScrolledIdRef.current = null;
    }
  }, [idSelected, allVehicles]);

  const handleRowClick = vehicle => {
    setMenuPosition(null);
    const vId = vehicle.device_id || vehicle.id;
    if (vId === rowActive) {
      getVehicle(null);
    } else {
      getVehicle(vehicle);
    }
  };

  const handleClickMenu = (event, rowIndex, vehicle) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    let top = rect.bottom - 134;
    let left = rect.left + 38;

    setMenuPosition({ top, left });
    setVehicleSub(vehicle);
  };

  const handleCloseMenu = () => {
    setMenuPosition(null);
  };

  const handleSubmenuOpen = (event, type) => {
    const rect = event.currentTarget.getBoundingClientRect();
    let top = rect.top;
    let left = rect.right;
    setSubmenuPosition({ top, left });
    setSubmenuOpen(true);
    setMenuType(type === 'report' ? reportSubmenu : roadSubmenu);
  };

  const handleSubmenuClose = () => {
    setSubmenuOpen(false);
  };

  const buildCameraRoute = tab => {
    const serial =
      vehicleSub?.device_serial ||
      '';
    const licensePlate =
      vehicleSub?.license_plate ||
      '';

    const query = new URLSearchParams({
      page: '1',
      tab
    });

    if (serial) query.set('serial', serial);
    if (licensePlate) query.set('license_plate', licensePlate);

    return `/app/camera?${query.toString()}`;
  };

  const handleQuickViewRoute = (e, menuItem) => {
    e.stopPropagation();

    if (menuItem.type === 'ROAD') {
      dispatch(
        setTimeSearching({
          id: vehicleSub.device_id || vehicleSub.id,
          license_plate: vehicleSub.license_plate || vehicleSub.vehicle?.license_plate,
          data: menuItem
        })
      );
    }

    navigate(`${menuItem.url}`);
    setMenuPosition(null);
  };

  return (
    <Box display="flex" flexDirection="column" height="100%">
      {showSearch && (
        <Box style={{ padding: '8px 2px' }}>
          <Box display="flex" alignItems="center" style={{ marginBottom: '0px' }}>
            <Typography
              style={{
                fontSize: '14px',
                fontWeight: '600'
              }}
            >
              Danh sách thiết bị
            </Typography>
            {baseDeviceCount !== undefined && (
              <Typography
                style={{
                  fontSize: '14px',
                  fontWeight: '700',
                  marginLeft: '2px'
                }}
              >
                : ({activeCount}/{baseDeviceCount})
              </Typography>
            )}
          </Box>
          {setCarStatus && (
            <Box style={{ marginBottom: '0px' }}>
              <CarStatusBar
                carStatus={carStatus}
                setCarStatus={setCarStatus}
                hideLabel
                iconFolder="cars"
                iconSize={26}
                iconRotate={90}
              />
            </Box>
          )}
          <Box display="flex" alignItems="center" style={{ position: 'relative' }}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              placeholder={
                canSearchAllAgencies
                  ? 'Tìm serial thiết bị / biển số ...'
                  : 'Tất cả thiết bị...'
              }
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" color="action" />
                  </InputAdornment>
                ),
                endAdornment: remoteLoading ? (
                  <InputAdornment position="end">
                    <CircularProgress size={14} />
                  </InputAdornment>
                ) : null,
                style: { height: 32, fontSize: '13px' }
              }}
            />

            {canSearchAllAgencies && remoteOnlyResults.length > 0 && (
              <Box
                style={{
                  position: 'absolute',
                  top: 34,
                  left: 0,
                  right: 0,
                  zIndex: 1400,
                  background: '#fff',
                  border: '1px solid #e0e0e0',
                  borderRadius: 4,
                  boxShadow: '0 4px 12px rgba(0,0,0,.15)',
                  maxHeight: 260,
                  overflowY: 'auto'
                }}
              >
                <Typography
                  style={{
                    fontSize: '11px',
                    color: '#888',
                    padding: '6px 10px 2px'
                  }}
                >
                  Thiết bị ở đại lý khác
                </Typography>
                <List style={{ padding: 0 }}>
                  {remoteOnlyResults.map(device => (
                    <ListItem
                      key={device.device_id}
                      button
                      className={classes.menuItem}
                      onClick={() => handlePickRemoteDevice(device)}
                      style={{ display: 'block', padding: '6px 10px' }}
                    >
                      <Typography style={{ fontSize: '13px', fontWeight: 600 }}>
                        {device.is_display_name && device.name
                          ? device.name
                          : device.license_plate || device.device_serial}
                      </Typography>
                      <Typography style={{ fontSize: '11px', color: '#666' }}>
                        {device.device_serial}
                        {device.agency_name ? ` · ${device.agency_name}` : ''}
                        {device.end_user_name ? ` · ${device.end_user_name}` : ''}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
          </Box>
        </Box>
      )}

      <TableVirtuoso
        ref={virtuosoRef}
        style={{ flex: 1, width: '100%' }}
        data={allVehicles}
        context={{ rowActive, hoverIndex, onRowClick: handleRowClick, setHoverIndex }}
        components={MINI_COMPONENTS}
        fixedHeaderContent={() => (
          <tr>
            {titleTableHeader.map(title => {
              return (
                <th
                  key={title.id}
                  style={{
                    width: title.width,
                    border: '1px solid rgba(60, 64, 67, 0.15)',
                    padding: '3px 0',
                    background: '#d9042f',
                    color: '#FFFFFF',
                    fontSize: '12px',
                    fontWeight: 500
                  }}
                >
                  <span
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      whiteSpace: 'pre-line'
                    }}
                  >
                    {title.name}
                  </span>
                </th>
              );
            })}
          </tr>
        )}
        itemContent={(index, vehicle) => {
          const vData = vehicle.vehicle || vehicle;
          const displayText =
            vData?.is_display_name && vData?.name
              ? vData.name
              : (vData?.license_plate || `Device ${vehicle.device_id || vehicle.id}`);

          return (
            <>
              <td style={{ width: titleTableHeader[0].width, height: 38, overflow: 'hidden', padding: '0' }}>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    height: '100%',
                    alignItems: 'center'
                  }}
                >
                  <VehicleTablecell
                    row={vehicle}
                    index={index}
                    displayText={displayText}
                  />
                </div>
              </td>

              {vehicle.debt ? (
                <td
                  colSpan={2}
                  style={{
                    width: Number(titleTableHeader[1].width) + Number(titleTableHeader[2].width),
                    height: 38,
                    overflow: 'hidden',
                    padding: 0
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      height: '100%',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <span style={{ color: '#D9042F', fontSize: '11px', fontWeight: 500 }}>
                      Hết hạn gói dịch vụ
                    </span>
                  </div>
                </td>
              ) : (
                <>
                  <td
                    style={{
                      width: titleTableHeader[1].width,
                      height: 38,
                      overflow: 'hidden',
                      padding: '0'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <span style={{ fontSize: '12px' }}>
                        {Math.floor(vehicle.speed_gps) || 0}
                      </span>
                    </div>
                  </td>

                  <td
                    style={{
                      width: titleTableHeader[2].width,
                      height: 38,
                      overflow: 'hidden',
                      padding: '0'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        height: '100%',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        gap: '6px',
                        paddingRight: '6px'
                      }}
                    >
                      <span style={{ fontSize: '11px' }}>
                        {vehicle
                          ? moment.unix(vehicle.created_at).format('DD/MM HH:mm:ss')
                          : '--'}
                      </span>

                      {!isCustomerCare && (
                        <div
                          style={{
                            cursor: 'pointer',
                            height: 16,
                            width: 15,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                          onClick={e => handleClickMenu(e, index, vehicle)}
                        >
                          <img alt="arrow" src="/static/iconSvg/arrow_right.svg" style={{ width: 8 }} />
                        </div>
                      )}
                    </div>
                  </td>
                </>
              )}
            </>
          );
        }}
      />
      {menuPosition && !isCustomerCare && (
        <div
          style={{
            position: 'fixed',
            top: menuPosition.top,
            left: menuPosition.left,
            backgroundColor: '#fff',
            boxShadow: '0px 2px 10px rgba(0,0,0,0.2)',
            zIndex: 9999,
            minWidth: '140px',
            borderRadius: '4px'
          }}
          onMouseLeave={() => {
            handleCloseMenu();
            handleSubmenuClose();
          }}
        >
          <List style={{ fontSize: '14px', padding: 0 }}>
            <ListItem
              className={classes.menuItem}
              onMouseEnter={e => handleSubmenuOpen(e, 'road')}
              style={{ padding: '5px 10px' }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%'
                }}
              >
                <span>Xem lộ trình</span>
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    height: '20px',
                    width: '20px'
                  }}
                >
                  <img alt="arrow" src="/static/iconSvg/arrow_right.svg" />
                </span>
              </div>
            </ListItem>

            {!isAgency && (
              <>
                <Divider />
                <ListItem
                  className={classes.menuItem}
                  onMouseEnter={e => handleSubmenuOpen(e, 'report')}
                  style={{
                    padding: '5px 10px',
                    pointerEvents: !isCar4G ? 'none' : 'auto'
                  }}
                  disabled={!isCar4G}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <span>Báo cáo</span>
                    <span
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                        height: '20px',
                        width: '20px'
                      }}
                    >
                      <img alt="arrow" src="/static/iconSvg/arrow_right.svg" />
                    </span>
                  </div>
                </ListItem>
              </>
            )}

            <Divider />
            <ListItem
              className={classes.menuItem}
              onClick={() => navigate(buildCameraRoute('image'))}
              style={{ padding: '5px 10px' }}
              disabled={!isCamera4G}
            >
              <span>Xem hình ảnh</span>
            </ListItem>

            <Divider />
            <ListItem
              className={classes.menuItem}
              onClick={() => navigate(buildCameraRoute('video'))}
              style={{ padding: '5px 10px' }}
              disabled={!isCamera4G}
            >
              <span>Xem lại video</span>
            </ListItem>
          </List>

          {submenuOpen && submenuPosition && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 141,
                backgroundColor: '#fff',
                boxShadow: '0px 1px 10px rgba(36, 36, 36, 0.2)',
                zIndex: 1000,
                minWidth: '200px',
                borderRadius: '4px'
              }}
              onMouseLeave={handleSubmenuClose}
              onMouseEnter={() => setSubmenuOpen(true)}
            >
              <List style={{ fontSize: '14px', padding: 0 }}>
                {menuType.map((item, index) => (
                  <React.Fragment key={index}>
                    <ListItem
                      className={classes.menuItem}
                      onClick={e => handleQuickViewRoute(e, item)}
                      style={{
                        padding: '5px 10px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <span>{item.name}</span>
                      {item.type === 'ROAD' && (
                        <span>
                          <img alt="clock" src="/static/iconSvg/clock_raw.svg" />
                        </span>
                      )}
                    </ListItem>
                    {index !== menuType.length - 1 && <Divider />}
                  </React.Fragment>
                ))}
              </List>
            </div>
          )}
        </div>
      )}
    </Box>
  );
};

export default React.memo(VehicleTableMini);
